import { useContext } from '@builder.io/qwik';
import { ArticleContext } from '~/contexts/ArticleContext';
import { usePropertyUrl } from '~/utilities/usePropertyUrl';

export function useMainCategoryPath() {
  const propertyUrl: string = usePropertyUrl();
  const article = useContext(ArticleContext);

  if (!article) return '';

  const mainCategory = article.mainCategory;

  return `${propertyUrl}${mainCategory?.path}`;
}
